import { noop } from 'lodash/fp';
import { InlinedFormElement } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { dateString, presence } from '../../validation';
import { commanderForm } from '../commanderForm';
import DateIntervalFields from './DateIntervalFields';

export const AUTOFILL_DAY_DIFFERENCE = 15;
const MAX_DAY_DIFFERENCE = 60;

interface DateRangeFiltersProps {
    autofillDayDifference?: number;
    maxDayDifference?: number;
    onFocus?: React.FocusEventHandler<HTMLDivElement>;
}

const DateRangeFilters = ({
    onFocus = noop,
    autofillDayDifference = AUTOFILL_DAY_DIFFERENCE,
    maxDayDifference = MAX_DAY_DIFFERENCE,
}: DateRangeFiltersProps) => (
    <Stack onFocus={onFocus} distribution="stretch" spacing="200">
        <DateIntervalFields
            autofillDayDifference={autofillDayDifference}
            constraints={dateConstraints}
            fieldNames={['startDate', 'endDate']}
            maxDayDifference={maxDayDifference}
            startProps={startProps}
            endProps={endProps}
        />
    </Stack>
);

const startProps = {
    label: <LocalizedText textKey={TextKey.Start} />,
    required: true,
    showMonthSelector: true,
};

const endProps = {
    label: <LocalizedText textKey={TextKey.End} />,
    required: true,
};

const commonDateConstraints = {
    dateString,
    presence,
};

const dateConstraints = {
    startDate: commonDateConstraints,
    endDate: commonDateConstraints,
};

export interface DateRangeFiltersValues {
    startDate: string;
    endDate: string;
}

export default commanderForm<DateRangeFiltersValues, DateRangeFiltersProps>({
    FormElement: InlinedFormElement,
    submitLabel: <LocalizedText textKey={TextKey.Ok} />,
})(DateRangeFilters);
